module.exports = __webpack_public_path__ + "static/img/reset1.9ef3ce12.png";